
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work_in_progress",
      function () {
        return require("private-next-pages/work_in_progress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work_in_progress"])
      });
    }
  